import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { Connect3MetricPopupComponent } from '../../connect3-metric-popup/connect3-metric-popup.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { MetricOptions } from 'src/app/gamification/command-center/models/metric-game';
import { MetricSelectorComponent } from '../../../../../../../reusables/metric-selector/metric-selector.component';
import { MetricSelectorService } from '../../../../../../../reusables/metric-selector/metric-selector.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cv-configure-board-connect3',
  templateUrl: './configure-board-connect3.component.html',
  styleUrls: ['./configure-board-connect3.component.scss']
})
export class ConfigureBoardConnect3Component implements OnInit, OnDestroy {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onMetricSelected: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  maxNumCards = 9;
  FreeSpaceObj = { position: 4, metric: { abbrev: this.getLocalizedMessage("Free_Space", "Free Space"), name: "Free Space", metricID: -1, target: null } };
  metricsSource: string = "Connect3 Choose Metrics From Card";
  currentPosition: number = 0;
  metricSelected = [];
  isLoadingTargets: boolean = false;
  hasFreeSpace: boolean = false;
  temporalObject = {
    metric: {
      metricID: 0
    }
  };
  metrics: any;
  cardHover = [];
  timeoutHandlerDebounce?: NodeJS.Timeout;
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private modalService: NgbModal,
    private navigationService: NavigationService,
    private metricFormatter: GenericMetricFormatterPipe,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    public metricSelectorService: MetricSelectorService,
    public cvConfigService: CvConfigurationService,
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    if (this.gs.modified.item.Connect3Positions != undefined && this.gs.modified.item.Connect3Positions.length > 0) {
      //Edit Mode so load the connect3 Cards
      //Validate if the Game had a Free Space
      if (this.gs.modified.item.Connect3Positions.length == 8) {
        this.gs.modified.item.Connect3Positions.push(this.FreeSpaceObj);
        this.hasFreeSpace = true;
      } else if (this.gs.modified.item.Connect3Positions.find(m => m.metric.metricID === -1) != undefined) {
        this.hasFreeSpace = true;
        this.temporalObject = this.gs.modified.item.Connect3Positions[4]; //Save the temporal object
      }
      //Sort the Positions
      this.gs.modified.item.Connect3Positions.sort((a, b) => {
        return (a.position > b.position) ? 1 : -1;
      });
    } else {
      //Prepare the GameBoard Cards when the mode is create
      this.gs.modified.item.Connect3Positions = [];
      for (var i = 0; i < this.maxNumCards; i++) {
          this.gs.modified.item.Connect3Positions[i] = { position: i, metric: null, targetObj: null };
      }
    }
    
    for(var i = 0; i < this.gs.modified.item.Connect3Positions.length; i++){
      this.cardHover.push(false);
    }    
    this.isCxone = this.cvConfigService.isCxOne;
  }

  ngOnDestroy(): void {
  }

  launchMetricSelector (position) {
    this.currentPosition = position;
    //Check if the metric was added on the Connect3Positions
    if (this.gs.modified.item.Connect3Positions[position].metric != null) {
      //Open the PopUp
      this.metricSelected = [this.gs.modified.item.Connect3Positions[position].metric];
      this.openMetricModal(this.currentPosition);
    } else { // Empty Card then Open Metric Selector
      let selectedMetric = null;

      //needed to filter metrics based on game type
      this.metricSelectorService.filterParams = this.gamesService.getGameTypeMetricFilter(this.gs.modified.item.definition.GameType);

      const metricSelector = this.metricSelectorService.openModalForSingleMetric(MetricSelectorComponent, selectedMetric);
      const newSelectedMetrics = [];
      metricSelector.result.then((metricSelectorResult) => {
        if (metricSelectorResult) {
          metricSelectorResult?.forEach(m => {
            newSelectedMetrics.push({
              metricID: m.MetricID,
              abbrev: m.Abbreviation,
              name: m.MetricName,
              conversionType: m.ConversionType,
              direction: m.DefaultDirection,
            });
          });
          this.metricSelected = newSelectedMetrics;
          //openMetricModal is opening the modal for Connect3 targets
          this.openMetricModal(this.currentPosition);
          this.onMetricSelected.emit({
              mID: newSelectedMetrics[0].metricID,
              mAbr: newSelectedMetrics[0].abbrev,
              mName: newSelectedMetrics[0].name,
              mDir: newSelectedMetrics[0].direction,
              mCT: newSelectedMetrics[0].conversionType,
          });
        }
    });
    }
  }

  randomize(list) {
    if (list == null || list.length < 1)
      return null;
    var curIdx = list.length;
    var tVal;
    var rIdx;

    while (curIdx != 0) {
      rIdx = Math.floor(Math.random() * curIdx);
      curIdx--;

      tVal = list[curIdx];
      list[curIdx] = list[rIdx];
      list[rIdx] = tVal;
    }

    return list;
  }

  setFreeSpace () {
    if (this.hasFreeSpace) {
      this.temporalObject = this.gs.modified.item.Connect3Positions[4]; //Save the temporal object
      //Remove the metric on SelectedMetrics object if exists
      if (this.gs.modified.item.Connect3Positions != undefined && this.gs.modified.item.Connect3Positions[4].metric != null && this.gs.modified.item.Connect3Positions[4].metric.metricID !== -1) {
        this.gs.modified.item.SelectedMetrics.splice(this.gs.modified.item.SelectedMetrics.map((item) => { return item.metricID }).indexOf(this.gs.modified.item.Connect3Positions[4].metric.metricID), 1);
      }
      this.gs.modified.item.Connect3Positions[4] = this.FreeSpaceObj;
    } else {
      //Check if the temporal metric object is already added one the selected metrics list.
      if (this.gs.modified.item.SelectedMetrics == null)
        this.gs.modified.item.SelectedMetrics = [];

      //validate when the temporal object is empty
      if (this.temporalObject.metric == undefined) {
        this.gs.modified.item.Connect3Positions[4] = { position: 4, metric: null };
        return;
      }

      if (this.gs.modified.item.SelectedMetrics.filter((e) => {
        return e.metricID == this.temporalObject.metric.metricID;
      }).length > 0) {
        //Metric Added from another card - Reset the card in order to add a different metric and don't add the metric on Selected Metric List.
        this.gs.modified.item.Connect3Positions[4] = { position: 4, metric: null };
      } else {
        //There's no change on the metric list then Recover the temporal object
        if (this.temporalObject != null && this.temporalObject.metric.metricID !== -1) {
          this.gs.modified.item.Connect3Positions[4] = this.temporalObject;
          this.gs.modified.item.SelectedMetrics.push(this.temporalObject.metric);
        } else {
          //Clean temporal object then add a null metric
          this.gs.modified.item.Connect3Positions[4] = { position: 4, metric: null };
        }
      }
    }
  }

  loadMetricTargets() {
    if (!this.isLoadingTargets) {
      this.isLoadingTargets = true;
      let metricIDs = this.metrics.map((m) => { return m.metricID; });
      this.gamesService.loadMetricTargets(metricIDs).then((result) => {
        //this.gs.modified.item.Connect3Targets = result;
      });
    }
  }

  debounceFunction(callback: () => void = () => {}, time: number = 1000) {
    if (this.timeoutHandlerDebounce) clearTimeout(this.timeoutHandlerDebounce);
    this.timeoutHandlerDebounce = setTimeout(()=> {
      callback();
      this.timeoutHandlerDebounce = undefined;
    }, time);
  }

  openMetricModal (position: number) {
    //Don't open modal when it's a free Space,
    if (position == 4 && this.hasFreeSpace == true)
        return;

    this.navigationService.showOverlay = true;
    this.currentPosition = position;
    this.debounceFunction(() => {
      // zone.run will help to detect changes inside the Connect3MetricPopupComponent and render those changes
      this.zone.run(() => {
        const modalRef = this.modalService.open(Connect3MetricPopupComponent, {
          animation: true,
          backdropClass: 'stopScrolling',
          size: 'md modal-dialog-noborder-when-loading modal-dialog-centered'
        });
    
        //Sending input value
        modalRef.componentInstance.parentObj = this;
    
        modalRef.result.finally(() => {
          this.navigationService.showOverlay = false;
        });
      });
    }, 500); // wait 500 milisecond to launch the new modal
  }

  getFormattedData(value, conversionType): string{
    return this.metricFormatter.transform(value, conversionType);
  }

  deleteCard (card) {
    if (card.position >= 0) {
      this.gs.modified.item.SelectedMetrics.splice(this.gs.modified.item.SelectedMetrics.map((item) => { return item.metricID }).indexOf(this.gs.modified.item.Connect3Positions[card.position].metric.metricID), 1);
      this.gs.modified.item.Connect3Positions[card.position].metric = null;
      this.gs.modified.item.Connect3Positions[card.position].targetObj = null;
    }
  }

  getLocalizedMessage(key: string, defaultText: string): string{
    return this.gamesService.getLocalizedMessage(key, defaultText);
  }
}
